import dynamic from "next/dynamic";
const App = dynamic(() => import("../../../components/App"));
import Head from "next/head";
import Link from "next/link";
import { useRouter } from "next/router";
const Breadcrumb = dynamic(() => import("antd/es/breadcrumb"), { ssr: false });
const Row = dynamic(() => import("antd/es/row"), { ssr: false });
const Col = dynamic(() => import("antd/es/col"), { ssr: false });
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";

const ComponentEn = dynamic(() => import("./en"), {
  ssr: false,
});
const ComponentTh = dynamic(() => import("./th"), {
  ssr: false,
});

export async function getServerSideProps(ctx) {
  return {
    props: {
      ...(await serverSideTranslations(ctx?.locale, ["common"])),
      token: ctx?.req?.cookies?.token || null,
    },
  };
}

const Home = ({
  token,
  categoryMenu,
  hasSale,
  hasLive,
  dataSeo,
  dataReferrer,
}) => {
  const router = useRouter();
  const { locale } = router;

  const { t } = useTranslation("common");

  return (
    <App
      token={token}
      categoryMenu={categoryMenu}
      hasSale={hasSale}
      hasLive={hasLive}
      dataSeo={dataSeo}
      dataReferrer={dataReferrer}
    >
      <Head>
        <title>Privacy policy</title>
      </Head>
      <Row justify="center" className="mt-5 mb-5">
        <Col xs={22} sm={22} md={22} lg={22} xl={20}>
          <Breadcrumb
            items={[
              {
                key: "home",
                title: <Link href={`/`}>{t("home")}</Link>,
              },
              {
                key: "terms-service-privacy",
                title: `${t("terms-service-privacy")}`,
              },
            ]}
          />
          {locale == "th" ? <ComponentTh /> : <ComponentEn />}
        </Col>
      </Row>
    </App>
  );
};

export default Home;
